import React, {Component} from 'react';
import propTypes from "prop-types";
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as Actions from '../actions';
// import {Link} from 'react-router-dom';
import lang from '../constants/Languages.js';

//import components

import withTitle from '../scripts/WithTitle.js';

//img
import logoImg from '../assets/icons/pbl-logo-login.svg';
import logoImgContrast from '../assets/icons/pbl-logo-login-contrast.svg';
import loader from '../assets/loading.svg';

class Login extends Component {
    constructor(props) {
         super(props);

         this.state = {
             username: '',
             password: '',
             submitted: false
         };
     };

    componentDidMount() {
        const { actions } = this.props;

        // reset login status
        actions.logout();
    };

    componentWillReceiveProps(nextProps) {
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;
        const { actions } = this.props;

        if (username && password) {
            actions.login(username, password);
        }
    };

    render() {
        const { loggingIn, clang } = this.props;
        const { username, password, submitted } = this.state;

        return (
           <section className="login">
               <div className="login__container">
                   <h2 className="login__title">{lang[clang].login_page.title}</h2>
                   <div className="login__img-container">
                       <img className="login__img" src={logoImg} alt={lang[clang].alt.logo}/>
                       <img className="login__img contrast" src={logoImgContrast} alt={lang[clang].alt.logo}/>
                   </div>
                   <form name="form" onSubmit={this.handleSubmit} className="login__form">
                       <div className={'login__form-group' + (submitted && !username ? ' has-error' : '')}>
                           <label htmlFor="username" className="login__form-label">{lang[clang].login_page.username}</label>
                           <input type="text" className="login__form-input" name="username" value={username} onChange={this.handleChange} />
                           {submitted && !username &&
                               <div className="login__form-required">{lang[clang].login_page.username_required}</div>}
                       </div>
                       <div className={'login__form-group' + (submitted && !password ? ' has-error' : '')}>
                           <label htmlFor="password" className="login__form-label">{lang[clang].login_page.password}</label>
                           <input type="password" className="login__form-input" name="password" value={password} onChange={this.handleChange} />
                           {submitted && !password &&
                               <div className="login__form-required">{lang[clang].login_page.password_required}</div>}
                       </div>
                       <div>
                           <button className={'login__btn' + (username && password ? ' active' : ' disabled')} title={lang[clang].login_page.login}>
                               {lang[clang].login_page.login}
                           </button>
                           {loggingIn &&
                               <img src={loader} className="login__loader" alt={lang[clang].alt.loader}/>
                           }
                       </div>
                   </form>
               </div>
           </section>
        );
    };
};

Login.propTypes = {
    clang: propTypes.string.isRequired,
    actions: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    loggingIn: state.authentication.loggingIn,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js